import { AxiosInstance } from 'axios'

export function getTaskMetricsCountsResponse(axios: AxiosInstance) {
  return axios({
    url: '/v1/user-tasks/insp/metrics/counts',
    method: 'get',
  })
}
